<template>
  <v-container fluid fill-height>
    <v-layout column>
      <h1 class="display-1 my-4 text-xs-center">Listings</h1>
      <listings-map></listings-map>
    </v-layout>
  </v-container>
</template>

<script>
import ListingsMap from '../components/ListingsMap';

export default {
  name: 'Listings',
  metaInfo: {
    title: 'Listings by Map',
  },
  components: {
    ListingsMap,
  },
};
</script>
